/**
 * ui-renderers/suggestions.ts
 * Quick-suggestion chips rendered below the input.
 */

import { dom } from '../dom';

export const SUGGESTIONS: Record<string, string[]> = {
  matters:   ['How do I create a matter?', 'What is a matter reference?', 'How do I assign an advocate?'],
  invoices:  ['How do I create an invoice?', 'What payment methods are supported?', 'How do I apply a retainer?'],
  documents: ['How do I upload a document?', 'What file types are supported?', 'How do I share a document?'],
  tasks:     ['How do I set task priority?', 'What are task quadrants?', 'How do I assign a task?'],
  messages:  ['How do I send a client update?', 'Can I attach files to messages?'],
  settings:  ['How do I update branding?', 'How do I add a custom domain?', 'How do I invite a team member?'],
  _default:  ['What can Akili Suite do?', 'How do I get started?', 'What is a retainer account?'],
};

export function renderSuggestions() {
  const container = dom.suggestions;
  if (!container) return;
  const section = (window as any)._currentSection || '_default';
  const list    = SUGGESTIONS[section] || SUGGESTIONS._default;
  container.innerHTML = '';
  list.forEach((s, idx) => {
    const btn = document.createElement('button');
    btn.className = 'ai-sug-btn';
    btn.type = 'button';
    btn.textContent = s;
    btn.style.animationDelay = (idx * 0.07) + 's';
    btn.addEventListener('click', () => {
      const inp = dom.input;
      if (inp) { inp.value = s; }
      document.dispatchEvent(new CustomEvent('akili:suggestion-click'));
    });
    container.appendChild(btn);
  });
}

export function hideSuggestions() {
  const s = dom.suggestions;
  if (s) s.innerHTML = '';
}
